<template>
  <button @click="click" :class="classModifier">{{ name }}</button>
</template>

<script src="./menu-button.js"></script>
<style src="./menu-button.scss" lang="scss"></style>
